// src/reportWebVitals.js
/**
 * Collects and forwards core Web Vitals metrics.
 *
 * Pass in a callback (e.g. console.log or your analytics wrapper) and each
 * metric will be forwarded as soon as it becomes available.
 *
 * @example
 *   import reportWebVitals from './reportWebVitals';
 *   reportWebVitals(console.log);
 *
 * @param {(metric: import('web-vitals').Metric) => void} onPerfEntry
 *        Callback that receives each metric object.
 */
export default function reportWebVitals(onPerfEntry) {
  if (typeof onPerfEntry !== "function") return;

  // Dynamically import to keep the main bundle lean.
  import("web-vitals")
    .then((vitals) => {
      // Build a list of metric functions that exist in the current
      // version of the `web-vitals` package.  From v3 onwards `getFID`
      // was replaced by `getINP`, so we include whichever is available.
      const metricFns = [
        vitals.getCLS,
        vitals.getFID || vitals.getINP,
        vitals.getFCP,
        vitals.getLCP,
        vitals.getTTFB,
      ].filter(Boolean); // remove missing metrics

      metricFns.forEach((fn) => fn(onPerfEntry));
    })
    .catch((error) => {
      // Silently swallow in production, but log in dev for visibility
      if (process.env.NODE_ENV === "development") {
        console.error("Failed to load web-vitals:", error);
      }
    });
}
